import React from 'react';
import { Box, IconButton, Tooltip } from '@mui/material';
import { GridColDef } from '@mui/x-data-grid';
import { SkillResponse, SubSkillResponse } from '../types';
import Icons from '../../../components/icons';

export const getSkillTableColumns = (
  handleEditClick: (skill: SkillResponse) => void
): GridColDef[] => [
  {
    field: 'skillName',
    headerName: 'Skill Name',
    flex: 1,
    minWidth: 160,
    headerAlign: 'left',
    align: 'left'
  },
  {
    field: 'totalSubSkills',
    headerName: 'Total Sub-Skills',
    flex: 1,
    minWidth: 160,
    headerAlign: 'left',
    align: 'left',
    type: 'number'
  },
  {
    field: 'actions',
    headerName: 'Actions',
    sortable: false,
    minWidth: 120,
    headerAlign: 'center',
    align: 'center',
    renderCell: (params) => (
      <Tooltip title='Edit'>
        <IconButton
          onClick={() => handleEditClick(params.row as SkillResponse)}
        >
          <Icons.EditBlackOutlined />
        </IconButton>
      </Tooltip>
    )
  }
];

export const getSubSkillColumns = (
  onEdit: (subSkill: SubSkillResponse) => void,
  onRemove: (id: string) => void
): GridColDef[] => [
  {
    field: 'description',
    headerName: 'Description',
    flex: 1,
    minWidth: 160,
    headerAlign: 'left',
    align: 'left'
  },
  {
    field: 'scoringTypeName',
    headerName: 'Scoring Type',
    flex: 1,
    minWidth: 140,
    headerAlign: 'left',
    align: 'left'
  },
  {
    field: 'order',
    headerName: 'Order',
    width: 80,
    headerAlign: 'center',
    align: 'center',
    type: 'number'
  },
  {
    field: 'maxMarks',
    headerName: 'Max Marks',
    width: 110,
    headerAlign: 'center',
    align: 'center',
    type: 'number',
    renderCell: ({ value }) => (value != null ? value : '-')
  },
  {
    field: 'actions',
    headerName: 'Actions',
    sortable: false,
    width: 100,
    headerAlign: 'center',
    align: 'center',
    renderCell: (params) => {
      const row = params.row as SubSkillResponse;
      return (
        <Box>
          <Tooltip title='Edit'>
            <IconButton size='small' onClick={() => onEdit(row)}>
              <Icons.EditBlackOutlined />
            </IconButton>
          </Tooltip>
          <Tooltip title='Remove'>
            <IconButton size='small' onClick={() => onRemove(row.id)}>
              <Icons.Delete />
            </IconButton>
          </Tooltip>
        </Box>
      );
    }
  }
];
